import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { FlyoutWrapper } from '../_Flyout/FlyoutWrapper.js';
import { hostClass } from './ActionFlyout.styles.js';

var defaultProps = {
  preferOpenToLeft: false
};
var ActionFlyoutPresentation = fComp(function (_a) {
  var _cleanupClassObject;
  var id = _a.id,
    children = _a.children,
    className = _a.className,
    noMargin = _a.noMargin,
    isStencilHost = _a.isStencilHost,
    htmlAttrs = _a.htmlAttrs,
    ariaLabelledBy = _a.ariaLabelledBy,
    onKeyDown = _a.onKeyDown,
    preferOpenToLeft = _a.preferOpenToLeft,
    props = __rest(_a, ["id", "children", "className", "noMargin", "isStencilHost", "htmlAttrs", "ariaLabelledBy", "onKeyDown", "preferOpenToLeft"]);
  return (
    /*#__PURE__*/
    // TODO: The "as"-Property of htmlAttrs has a conflicting type with that of the Host element. Find a solution.
    // @ts-ignore
    React.createElement(Host, Object.assign({
      id: id,
      className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
      isStencilHost: isStencilHost
    }, Object.assign(Object.assign({}, htmlAttrs), {
      role: "menu",
      "aria-labelledby": ariaLabelledBy
    })), /*#__PURE__*/React.createElement(FlyoutWrapper, Object.assign({
      preferOpenToLeft: preferOpenToLeft,
      hasTabIndex: false,
      onKeyDown: onKeyDown
    }, props), children))
  );
}, defaultProps);
ActionFlyoutPresentation.displayName = "ActionFlyoutPresentation";

export { ActionFlyoutPresentation, defaultProps };
